import { render, staticRenderFns } from "./form-supInforme.vue?vue&type=template&id=a4c17958&scoped=true&"
import script from "./form-supInforme.vue?vue&type=script&lang=js&"
export * from "./form-supInforme.vue?vue&type=script&lang=js&"
import style0 from "./form-supInforme.vue?vue&type=style&index=0&id=a4c17958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c17958",
  null
  
)

export default component.exports